import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { addReport, modifyReport } from 'features/report/reportAddSlice'
import { isPresent, noop } from 'utils'

export const REPORT_UNKNOWN = 'UNKNOWN'
export const REPORT_ADD = 'ADD'
export const REPORT_MODIFY = 'MODIFY'

const modeUnknown = {
  mode: REPORT_UNKNOWN,
  pageTitle: '',
  saveFunc: noop(),
  text: '',
  domainPathVariable: null,
  reportIdPathVariable: null,
}

const modeAdd = {
  mode: REPORT_ADD,
  pageTitle: '맞춤보고서 만들기',
  saveFunc: addReport,
  text: '확인',
  domainPathVariable: null,
  reportIdPathVariable: null,
}

const modeModify = {
  mode: REPORT_MODIFY,
  pageTitle: '맞춤보고서 수정',
  saveFunc: modifyReport,
  text: '저장',
}

const useReportViewMode = () => {
  const { domain, reportId } = useParams()
  const [mode, setMode] = useState(modeUnknown)

  useEffect(() => {
    if (isPresent(reportId)) {
      modeModify.domainPathVariable = domain
      modeModify.reportIdPathVariable = reportId
      setMode(modeModify)
    } else {
      setMode(modeAdd)
    }
  }, [domain, reportId])

  return mode
}

export default useReportViewMode
